import { AllCommands } from '../../hard_decoration/commands/all_cmds'
import { HardDecCore } from '../../hard_decoration/hard_dec_core'
import shape from '../../shape'
import { StuffCtrlBar } from '../../shape/shape_ctrl_bar'
import { CeilingAdd } from '../object_action/ceiling_add'
import { StuffAdd } from '../object_action/stuff_common_add'
import { StuffSignals } from './stuff_signal'

export class CeilingMove extends StuffAdd {
    /**
     * @param {Ceiling} actor
     */
    constructor(actor) {
        super()
        this.actor = actor
    }
    handle() {
        this.entry()
        StuffCtrlBar.hide()
    }
    mouseUp(event) {
        const actor = this.actor
        this.exit()
        const below = CeilingAdd.intersectBelow(event)
        const type = below?.type
        const name = below?.name
        actor.afterMove = true
        if (type === 'eArea') {
            actor.expand(shape.find_uuid(name))
        } else {
            const core = new HardDecCore()
            const pixiPose = shape.event_point({ data: { global: event } })
            core.execute(
                new AllCommands('ProductUpdateCmd', {
                    add: [],
                    mod: [
                        actor.modifiedPB({
                            position: {
                                x: pixiPose.x,
                                y: pixiPose.y,
                                z: actor.position.z,
                            },
                            width: 70,
                            height: 70,
                            angle: 0,
                        }),
                    ],
                    del: [],
                })
            )
        }
    }
    move(event) {
        this.actor.move(event)
    }
    entry() {
        this.enable = true
        this.cancel(this.exit.bind(this))
        StuffSignals.mouseUp.add(this.mouseUp.bind(this))
        StuffSignals.mouseDownMove.add(this.move.bind(this))
    }
    exit() {
        if (!this.enable) return
        StuffSignals.mouseUp.restore()
        StuffSignals.mouseDownMove.restore()
        this.actor = null
    }
}
